/**
 * Selection card constants and placeholders.
 *
 * @class SelectionCardTypes
 * @name types
 * @memberof Mojito.Modules.EventCards.Selection
 */
export default class SelectionCardTypes {}

/**
 * Placeholder selection passed to the card selection button when the real selection is not in the
 * store yet, such as while the card skeleton is showing. Keeps the button props stable while event
 * and market requests are in flight.
 *
 * @constant BOGUS_SELECTION
 * @type {{ id: string, type: string }}
 * @memberof Mojito.Modules.EventCards.Selection.types
 */
SelectionCardTypes.BOGUS_SELECTION = {
    id: 'BOGUS_SELECTION',
    type: 'UNKNOWN',
};
